import React, { FC } from 'react';
import Link, { LinkProps } from 'next/link';

import {
  RSDetailHeaderButtonAnchor,
  RSDetailHeaderButtonAnchorProps,
} from '../RSDetailHeaderButtonAnchor';
import { buildUrl } from 'src/utils/request-url';

export type RSDetailHeaderButtonLinkProps = Omit<
  LinkProps,
  'passHref' | 'legacyBehavior'
> & {
  children?: RSDetailHeaderButtonAnchorProps['children'];
  variant?: RSDetailHeaderButtonAnchorProps['variant'];
  disabled?: RSDetailHeaderButtonAnchorProps['disabled'];
  isLoading?: RSDetailHeaderButtonAnchorProps['isLoading'];
};

export const RSDetailHeaderButtonLink: FC<RSDetailHeaderButtonLinkProps> = ({
  variant,
  disabled,
  isLoading,
  children,
  ...props
}) => {
  // Link互換(/reserveがあるなら削除する)再変換
  if (typeof props.href === 'string') props.href = buildUrl(props.href, 'next');
  return (
    <Link {...props} passHref legacyBehavior>
      <RSDetailHeaderButtonAnchor
        variant={variant}
        disabled={disabled}
        isLoading={isLoading}
      >
        {children}
      </RSDetailHeaderButtonAnchor>
    </Link>
  );
};
